import { Stack } from '@mui/material';
import { Typography } from '@upheal/design-system/components/Typography/Typography';

type MeteredPriceHeaderProps = {
    formattedPrice: string;
    capLabel: string;
};

export const MeteredPriceHeader = ({
    formattedPrice,
    capLabel,
}: MeteredPriceHeaderProps) => (
    <Stack gap={2} alignItems="center" px={1.25}>
        <Typography
            variant="h3"
            fontWeight="semibold"
            sx={{ letterSpacing: '-0.8px' }}
        >
            {formattedPrice}
            <Typography variant="h5" fontWeight="regular" component="span">
                /session
            </Typography>
        </Typography>
        <Typography
            variant="h5"
            fontWeight="semibold"
            color="ds.fg.accent2.primary"
        >
            {capLabel}
        </Typography>
    </Stack>
);
